module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("15VAZ"))).then(() => parcelRequire('5erN3'));